import { render, staticRenderFns } from "./QuestionnaireDataStatistics.vue?vue&type=template&id=3317de1c&scoped=true&"
import script from "./QuestionnaireDataStatistics.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireDataStatistics.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireDataStatistics.vue?vue&type=style&index=0&id=3317de1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3317de1c",
  null
  
)

export default component.exports